import * as React from "react";
import cotizacion_icon from "../../../UI/general/icon-quotation.svg";
import axios from "axios";

declare const window: any;

const STORAGE_KEY_PENDING = "pending_quotations";

const formatDate = () => {
  const now = new Date();
  let formatted = now.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return formatted.replace("AM", "a.m.").replace("PM", "p.m.");
};

const savePendingQuotation = (quotation: any) => {
  const pending = JSON.parse(localStorage.getItem(STORAGE_KEY_PENDING) || "[]");
  pending.push(quotation);
  localStorage.setItem(STORAGE_KEY_PENDING, JSON.stringify(pending));
};

const loadPendingQuotations = () => {
  return JSON.parse(localStorage.getItem(STORAGE_KEY_PENDING) || "[]");
};

const clearPendingQuotations = () => {
  localStorage.removeItem(STORAGE_KEY_PENDING);
};

const flushPendingQuotations = async () => {
  const pending = loadPendingQuotations();
  if (pending.length === 0) return;

  for (let q of pending) {
    try {
      await axios.post(
        "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/quotaton/send",
        q
      );
      console.log("Cotización enviada:", q);
    } catch (err) {
      console.warn("Error enviando cotización pendiente, se mantiene en cola", err);
      return; // Si falla, no borres ni sigas
    }
  }

  // Si todas se enviaron correctamente
  clearPendingQuotations();
};

export default function CotizacionContainer({
  theme,
  colors,
  setIsSideBar,
  isSideBar,
  isPortrait,
  selectedCotizacion,
  setSelectedCotizacion,
}) {
  const [alt, setAlt] = React.useState(false);
  const [nameQuotation, setNameQuotation] = React.useState("");
  const [phoneQuotation, setPhoneQuotation] = React.useState("");
  const [emailQuotation, setEmailQuotation] = React.useState("");
  const [isSendQuotation, setIsSendQuotation] = React.useState(false);
  const [statusQuotation, setStatusQuotation] = React.useState({});

  React.useEffect(() => {
    // cada vez que abre el módulo intentamos despachar cotizaciones pendientes
    if (window.hybrid && navigator.onLine) {
      flushPendingQuotations();
    }
  }, []);

  const handleBackQuotation = async () => {
    setIsSendQuotation(false);
    setStatusQuotation({});
    setNameQuotation("");
    setPhoneQuotation("");
    setEmailQuotation("");
    setSelectedCotizacion([]);
  };

  const handleSendQuotation = async () => {
    if (
      nameQuotation !== "" &&
      phoneQuotation !== "" &&
      emailQuotation !== "" &&
      selectedCotizacion.length > 0
    ) {
      let params: any = {
        name: nameQuotation,
        phone: phoneQuotation,
        destino: emailQuotation,
        properties: selectedCotizacion,
        project: window.project_id,
        link: window.location.href,
        date: formatDate(),
      };

      if (window.hybrid) {
        if (navigator.onLine) {
          // hay internet → enviamos normal
          try {
            let res: any = await axios.post(
              "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/quotaton/send",
              params
            );
            setIsSendQuotation(true);
            setStatusQuotation(res.data.statusCode);

            // luego de enviar, revisamos si hay cotizaciones pendientes
            await flushPendingQuotations();
          } catch (err) {
            console.error("Error enviando cotización, se guarda localmente", err);
            savePendingQuotation(params);
            setIsSendQuotation(true);
          }
        } else {
          // no hay internet → guardamos localmente
          savePendingQuotation(params);
          setIsSendQuotation(true);
          setStatusQuotation({ offline: true });
        }
      } else {
        // modo web → siempre enviamos
        let res: any = await axios.post(
          "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/quotaton/send",
          params
        );
        setIsSendQuotation(true);
        setStatusQuotation(res.data.statusCode);
      }
    }
  };

  return !isPortrait ? (
    <div className={`cotizacion-container ${theme}`}>
      <div
        className={`cotizacion-sidebar ${
          isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"
        }`}
      >
        <div className="cotizacion-sidebar-close">
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(false);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
        {!isSendQuotation && (
          <div className="cotizacion-sidebar-logo">
            <img src={cotizacion_icon} alt="" />
            <div className="cotizacion-sidebar-title">COTIZACIÓN</div>
            <div className="cotizacion-sidebar-subtitle">
              Llena los campos y recibirás en tu correo más información de los
              inmuebles.
            </div>
          </div>
        )}
        {!isSendQuotation ? (
          <div className="cotizacion-sidebar-contenido">
            <div className="cotizacion-sidebar-form">
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Nombre</label>
                <input
                  type="text"
                  value={nameQuotation}
                  onChange={(e) => setNameQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Celular</label>
                <input
                  type="text"
                  value={phoneQuotation}
                  onChange={(e) => setPhoneQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Correo</label>
                <input
                  type="email"
                  value={emailQuotation}
                  onChange={(e) => setEmailQuotation(e.target.value)}
                />
              </div>
            </div>
            <div className="cotizacion-sidebar-inmuebles">
              <div className="cotizacion-sidebar-inmuebles-title">
                INMUEBLES SELECCIONADOS
              </div>
              <div className="cotizacion-sidebar-inmuebles-subtitle">
                Selecciona los productos que desees cotizar desde la opción
                inmuebles en el menú principal.
              </div>
              {selectedCotizacion?.length > 0 ? (
                selectedCotizacion.map((inmueble: any, index: number) => (
                  <div
                    key={index}
                    className="cotizacion-sidebar-inmuebles-inmueble"
                  >
                    <div className="cotizacion-sidebar-inmuebles-inmueble-data">
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-title">
                        {inmueble.property}
                      </div>
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-subtitle">
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #2"
                          )?.value
                        }
                        {inmueble?.values?.find(
                          (e) => e.hierarchicalLevel === "Jerarquico #2"
                        ) !== undefined
                          ? "  /  "
                          : null}
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #1"
                          )?.value
                        }
                      </div>
                    </div>
                    <div
                      className="cotizacion-sidebar-inmuebles-inmueble-remove"
                      onClick={() =>
                        setSelectedCotizacion((prev) =>
                          prev.filter(
                            (e: any) =>
                              JSON.stringify(e) !== JSON.stringify(inmueble)
                          )
                        )
                      }
                    >
                      <i className="fas fa-xmark"></i>
                    </div>
                  </div>
                ))
              ) : (
                <div className="cotizacion-sidebar-inmuebles-not-inmueble">
                  No hay cotizaciones seleccionadas.
                </div>
              )}
            </div>
            <div
              className={`cotizacion-sidebar-send ${
                nameQuotation !== "" &&
                phoneQuotation !== "" &&
                emailQuotation !== "" &&
                selectedCotizacion.length > 0
                  ? "active"
                  : ""
              }`}
              style={
                nameQuotation !== "" &&
                phoneQuotation !== "" &&
                emailQuotation !== "" &&
                selectedCotizacion.length > 0
                  ? { backgroundColor: colors?.main_buttons }
                  : {}
              }
              onClick={() => handleSendQuotation()}
            >
              Enviar
            </div>
            <div className="cotizacion-sidebar-send-legal">
              Llena todos los campos para continuar.
            </div>
            {/* <div className="cotizacion-sidebar-text-legal">
              Al presionar <strong>ENVIAR</strong> estoy aceptando todos los
              }}
              onClick={() => handleSendQuotation()}
            >
              Enviar
            </div>
            <div className="cotizacion-sidebar-send-legal">
              Llena todos los campos para continuar.
            </div>
            {/* <div className="cotizacion-sidebar-text-legal">
              Al presionar <strong>ENVIAR</strong> estoy aceptando todos los
              términos  y condiciones. tratados en nuestra{" "}
              <a href="">Declaración de privacidad</a>.
            </div> */}
          </div>
        ) : (
          <div className="cotizacion-sidebar-contenido-res">
            <div className="cotizacion-sidebar-contenido-res-title">
              Hemos recibido tu solicitud
            </div>
            {/* <div className="cotizacion-sidebar-contenido-res-description">
              En breve recibirás un correo con la información de los inmuebles
              que te han interesado.
            </div> */}
            <div
              className="cotizacion-sidebar-contenido-res-back"
              style={{ backgroundColor: colors?.main_buttons }}
              onClick={() => handleBackQuotation()}
            >
              Cerrar
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className={`cotizacion-container ${theme}`}>
      <div className={`cotizacion-button ${isSideBar ? "hidden" : "show"}`}>
        <img src={cotizacion_icon} alt="Asoleación" />
      </div>
      <div
        className={`cotizacion-sidebar-mobile ${
          isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"
        }`}
        onAnimationEnd={() => {
          if (!isSideBar) setIsSideBar(false);
        }}
      >
        <div className="cotizacion-sidebar-logo">
          <img src={cotizacion_icon} alt="" />
          <div className="cotizacion-sidebar-title">COTIZACIÓN</div>
          <div className="cotizacion-sidebar-subtitle">
            Llena los campos y recibirás en tu correo más información de los
            inmuebles.
          </div>
        </div>
        {!isSendQuotation ? (
          <div className="cotizacion-sidebar-contenido">
            <div className="cotizacion-sidebar-form">
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Nombre</label>
                <input
                  type="text"
                  value={nameQuotation}
                  onChange={(e) => setNameQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Celular</label>
                <input
                  type="text"
                  value={phoneQuotation}
                  onChange={(e) => setPhoneQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Correo</label>
                <input
                  type="email"
                  value={emailQuotation}
                  onChange={(e) => setEmailQuotation(e.target.value)}
                />
              </div>
            </div>
            <div className="cotizacion-sidebar-inmuebles">
              <div className="cotizacion-sidebar-inmuebles-title">
                INMUEBLES SELECCIONADOS
              </div>
              <div className="cotizacion-sidebar-inmuebles-subtitle">
                Selecciona los productos que desees cotizar desde la opción
                inmuebles en el menú principal.
              </div>
              {selectedCotizacion?.length > 0 ? (
                selectedCotizacion.map((inmueble: any, index: number) => (
                  <div
                    key={index}
                    className="cotizacion-sidebar-inmuebles-inmueble"
                  >
                    <div className="cotizacion-sidebar-inmuebles-inmueble-data">
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-title">
                        {inmueble.property}
                      </div>
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-subtitle">
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #2"
                          )?.value
                        }
                        {inmueble?.values?.find(
                          (e) => e.hierarchicalLevel === "Jerarquico #2"
                        ) !== undefined
                          ? "  /  "
                          : null}
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #1"
                          )?.value
                        }
                      </div>
                    </div>
                    <div
                      className="cotizacion-sidebar-inmuebles-inmueble-remove"
                      onClick={() =>
                        setSelectedCotizacion((prev) =>
                          prev.filter(
                            (e: any) =>
                              JSON.stringify(e) !== JSON.stringify(inmueble)
                          )
                        )
                      }
                    >
                      <i className="fas fa-xmark"></i>
                    </div>
                  </div>
                ))
              ) : (
                <div className="cotizacion-sidebar-inmuebles-not-inmueble">
                  No hay cotizaciones seleccionadas.
                </div>
              )}
            </div>
            <div
              className={`cotizacion-sidebar-send ${
                nameQuotation !== "" &&
                phoneQuotation !== "" &&
                emailQuotation !== "" &&
                selectedCotizacion.length > 0
                  ? "active"
                  : ""
              }`}
              style={
                nameQuotation !== "" &&
                phoneQuotation !== "" &&
                emailQuotation !== "" &&
                selectedCotizacion.length > 0
                  ? { backgroundColor: colors?.main_buttons }
                  : {}
              }
              onClick={() => handleSendQuotation()}
            >
              Enviar
            </div>
            <div className="cotizacion-sidebar-send-legal">
              Llena todos los campos para continuar.
            </div>
            {/* <div className="cotizacion-sidebar-text-legal">
              Al presionar <strong>ENVIAR</strong> estoy aceptando todos los
              términos y condiciones tratados en nuestra{" "}
              <a href="">Declaración de privacidad</a>.
            </div> */}
          </div>
        ) : (
          <div className="cotizacion-sidebar-contenido-res">
            <div className="cotizacion-sidebar-contenido-res-title">
              Hemos recibido tu solicitud
            </div>
            <div className="cotizacion-sidebar-contenido-res-description">
              En breve recibirás un correo con la información de los inmuebles
              que te han interesado.
            </div>
            <div
              className="cotizacion-sidebar-contenido-res-back"
              onClick={() => handleBackQuotation()}
            >
              Cerrar
            </div>
          </div>
        )}
        <div className={`sidebar-container-portrait-close  ${theme}`}>
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(false);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
